export { ScrollPoint, scrollPointSchema } from './scroll-point';
